import React, { useState, useEffect } from "react"
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './myBooking.css'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { myBookings } from "../../api/booking"
// -------------------------------------------------

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const MyBooking = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  //user
  const [user, setUser] = useState('')
  //Boooking States

  //Flight
  const [filghtBooking, setFlightBooking] = useState([])
  //bus
  const [busBooking, setBusBooking] = useState([])
  //cab
  const [cabBooking, setCabBooking] = useState([])
  //visa
  const [visaBooking, setVisaBooking] = useState([])
  //cruise
  const [cruiseBooking, setCruiseBooking] = useState([])
  //hotel
  const [hotelBooking, setHotelBooking] = useState([])
  //train
  const [trainBooking, setTrainBooking] = useState([])
  //package
  const [packageBooking, setPackageBooking] = useState([])
  //insurance
  const [insuranceBooking, setInsuranceBooking] = useState([])

  const bookings = async () => {
    const resp = await myBookings()
    //user 
    setUser(resp?.data?.user)
    //flight
    const flight = resp.data.bookings.filter((items) => {
      return items.type === 'flightBooking'
    })
    setFlightBooking(flight)

    //bus
    const bus = resp.data.bookings.filter((items) => {
      return items.type === 'busBooking'
    })
    setBusBooking(bus)

    //cab
    const cab = resp.data.bookings.filter((items) => {
      return items.type === 'cabBooking'
    })
    setCabBooking(cab)

    //visa
    const visa = resp.data.bookings.filter((items) => {
      return items.type === 'visaBooking'
    })
    setVisaBooking(visa)

    //cruise
    const cruise = resp.data.bookings.filter((items) => {
      return items.type === 'cruiseBooking'
    })
    setCruiseBooking(cruise)

    //hotel
    const hotel = resp.data.bookings.filter((items) => {
      return items.type === 'hotelBooking'
    })
    setHotelBooking(hotel)

    //train
    const train = resp.data.bookings.filter((items) => {
      return items.type === 'trainBooking'
    })
    setTrainBooking(train)

    //packages
    const packages = resp.data.bookings.filter((items) => {
      return items.type === 'packageBooking'
    })
    setPackageBooking(packages)

    //insurance
    const insurance = resp.data.bookings.filter((items) => {
      return items.type === 'insuranceBooking'
    })
    setInsuranceBooking(insurance)

  }
  useEffect(() => {
    bookings()
  }, [])
  insuranceBooking?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  filghtBooking?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  busBooking?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  cruiseBooking?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  cabBooking?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  trainBooking?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  visaBooking?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  packageBooking?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  hotelBooking?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));


  return (
    <>
      <Header />

      {/* Page Header */}
      <section className='booking-page-header'>
        <div className='container'>
          <div className='booking-page-icon'>
            <i className='fa-solid fa-ticket'></i>
          </div>
          <h1>My Bookings</h1>
          <p>Manage and track all your travel reservations</p>
        </div>
      </section>

      <section className='py-4'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-md-12'>
              <div className="card booking-main-card">
                <div className="card-header border-bottom">
                  <h4 className="card-header-title">All Reservations</h4>
                </div>
                <Box sx={{ width: '100%', p: 2 }}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider', pb: 2 }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                      <Tab label="Flight Booking" {...a11yProps(0)} />
                      <Tab label="Hotel Booking" {...a11yProps(1)} />
                      <Tab label="Package Booking" {...a11yProps(2)} />
                      <Tab label="Cab Booking" {...a11yProps(3)} />
                      <Tab label="Bus Booking" {...a11yProps(4)} />
                      <Tab label="Visa Booking" {...a11yProps(5)} />
                      <Tab label="Train Booking" {...a11yProps(6)} />
                      <Tab label="Cruise Booking" {...a11yProps(7)} />
                      <Tab label="Insurance Booking" {...a11yProps(8)} />
                    </Tabs>
                  </Box>
                  <CustomTabPanel value={value} index={0}>
                    <h6>Flight Booking</h6>
                    {filghtBooking?.map((items) => (

                      <div key={items?._id} class="card border mb-4">
                        <div class="card-header border-bottom d-md-flex justify-content-md-between align-items-center">
                          <div class="d-flex align-items-center">
                            <div class="icon-lg bg-light rounded-circle flex-shrink-0">
                              {/* <svg class="svg-inline--fa fa-plane" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plane" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                <path class="" fill="currentColor" d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"></path>
                              </svg> */}
                              <i className="fa-solid fa-jet-fighter-up"></i>
                            </div>
                            <div class="ms-2">
                              {/* <h6 class="card-title mb-0">{item.from} to {item?.to}</h6> */}
                              <ul class="nav nav-divider small">
                                <li class="nav-item">Booking ID: {items._id}</li>
                              </ul>
                            </div>
                          </div>
                          <div class="mt-2 mt-md-0">
                            <a href="#" class="btn btn-primary-soft mb-0">{items?.status === 'callNotPicked' ? 'Call Not Picked' : items?.status}</a>
                          </div>
                        </div>
                        <div class="card-body">
                          <div class="row g-3">
                            <div class="col-sm-6 col-md-4">
                              <span>Flight Class</span>
                              <h6 class="mb-0">{items?.flightClass}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Flight Type</span>
                              <h6 class="mb-0">{items?.flightType}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Special Fare</span>
                              <h6 class="mb-0">{items?.specialFare}</h6>
                            </div>


                            <div class="col-sm-6 col-md-4">
                              <span>Adults</span>
                              <h6 class="mb-0">{items?.passengerCount?.adult}</h6>
                            </div>
                            {items?.passengerCount?.child ?
                              <div class="col-sm-6 col-md-4">
                                <span>Child</span>
                                <h6 class="mb-0">{items?.passengerCount?.child}</h6>
                              </div>
                              :
                              <></>
                            }
                            {items?.passengerCount?.infant ?
                              <div class="col-sm-6 col-md-4">
                                <span>Infant</span>
                                <h6 class="mb-0">{items?.passengerCount?.infant}</h6>
                              </div>
                              :
                              <></>
                            }
                          </div>
                          <div class="row py-2">
                            <h6>Journey Info</h6>
                            <div class="table-responsive border-0">
                              <table class="table align-middle p-4 mb-0 table-hover table-shrink">
                                <thead class="table-light">
                                  <tr>
                                    <th scope="col" class="border-0">From</th>
                                    <th scope="col" class="border-0">To</th>
                                    <th scope="col" class="border-0">Departure Date</th>
                                    {items?.journeyInfo?.length === 1 && <th scope="col" class="border-0">Departure Time</th>}
                                    {items?.journeyInfo[0]?.returnDate && <th scope="col" class="border-0">Return Date</th>}
                                    {items?.journeyInfo[0]?.returnTime && <th scope="col" class="border-0">Return Time</th>}
                                  </tr>
                                </thead>
                                <tbody class="border-top-0">
                                  {items?.journeyInfo?.map((item) => (
                                    <tr>
                                      <td>{item?.from}</td>
                                      <td>{item?.to}</td>
                                      <td>{new Date(item?.departureDate)?.toDateString()}</td>
                                      {items?.journeyInfo?.length === 1 &&
                                        <td > {item?.departureTime}</td>}
                                      {item?.returnDate && < td > {new Date(item?.returnDate)?.toDateString()}</td>}
                                      {item?.returnTime && <td > {item?.returnTime}</td>}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={1}>
                    <h6>Hotel Booking</h6>
                    {hotelBooking?.map((items) => (
                      <>
                        <div class="card border mb-4">
                          <div class="card-header border-bottom d-md-flex justify-content-md-between align-items-center">
                            <div class="d-flex align-items-center">
                              <div class="icon-lg bg-light rounded-circle flex-shrink-0">
                                {/* <svg class="svg-inline--fa fa-plane" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plane" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                  <path class="" fill="currentColor" d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"></path>
                                </svg> */}
                                <i className="fa-solid fa-building"></i>
                              </div>
                              <div class="ms-2">
                                <h6 class="card-title mb-0">{items?.hotelData?.name}</h6>
                                <ul class="nav nav-divider small">
                                  <li class="nav-item">Booking ID: {items?._id}</li>
                                </ul>
                              </div>
                            </div>
                            <div class="mt-2 mt-md-0">
                              <a href="#" class="btn btn-primary-soft mb-0">{items?.status === 'callNotPicked' ? 'Call Not Picked' : items?.status}</a>

                            </div>
                          </div>
                          <div class="card-body">
                            <div class="row g-3">
                              <div class="col-sm-6 col-md-4">
                                <span>Mobile No</span>
                                <h6 class="mb-0">{user?.mobile}</h6>
                              </div>
                              <div class="col-sm-6 col-md-4">
                                <span>Email Id</span>
                                <h6 class="mb-0">{user?.email}</h6>
                              </div>
                              <div class="col-sm-6 col-md-4">
                                <span>Check In</span>
                                <h6 class="mb-0">{items?.checkIn && new Date(items?.checkIn).toDateString()}</h6>
                              </div>
                              <div class="col-sm-6 col-md-4">
                                <span>Check Out</span>
                                <h6 class="mb-0">{items?.checkOut && new Date(items?.checkOut).toDateString()}</h6>
                              </div>
                              <div class="col-sm-6 col-md-4">
                                <span>Adults</span>
                                <h6 class="mb-0">{items?.adultCount}</h6>
                              </div>
                              <div class="col-sm-6 col-md-4">
                                <span>Childs</span>
                                <h6 class="mb-0">{items?.childCount}</h6>
                              </div>

                              <div class="col-sm-6 col-md-4">
                                <span>Rooms</span>
                                <h6 class="mb-0">{items?.roomCount}</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ))}

                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={2}>
                    <h6>Package Booking</h6>
                    {packageBooking?.map((items) => (
                      <div key={items?._id} class="card border mb-4">
                        <div class="card-header border-bottom d-md-flex justify-content-md-between align-items-center">
                          <div class="d-flex align-items-center">
                            <div class="icon-lg bg-light rounded-circle flex-shrink-0">
                              {/* <svg class="svg-inline--fa fa-plane" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plane" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                <path class="" fill="currentColor" d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"></path>
                              </svg> */}
                              <i className="fa-solid fa-earth-americas"></i>
                            </div>
                            <div class="ms-2">
                              <h6 class="card-title mb-0">{items?.packageData?.city}</h6>
                              <ul class="nav nav-divider small">
                                <li class="nav-item">Booking ID: {items?._id}</li>
                              </ul>
                            </div>
                          </div>
                          <div class="mt-2 mt-md-0">
                            <a href="#" class="btn btn-primary-soft mb-0">{items?.status === 'callNotPicked' ? 'Call Not Picked' : items?.status}</a>

                          </div>
                        </div>
                        <div class="card-body">
                          <div class="row g-3">
                            <div class="col-sm-6 col-md-4">
                              <span>Mobile No</span>
                              <h6 class="mb-0">{items?.mobile}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Email Id</span>
                              <h6 class="mb-0">{items?.email}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Package Name</span>
                              <h6 class="mb-0">{items?.packageData?.packageName}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Start Date</span>
                              <h6 class="mb-0">{new Date(items?.preferredDate?.from).toDateString()}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>End Date</span>
                              <h6 class="mb-0">{new Date(items?.preferredDate?.to).toDateString()}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Adults</span>
                              <h6 class="mb-0">{items?.noOfPersons?.adult}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Childs</span>
                              <h6 class="mb-0">{items?.noOfPersons?.child}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Infant</span>
                              <h6 class="mb-0">{items?.noOfPersons?.infant}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Days</span>
                              <h6 class="mb-0">{items?.packageData?.dayCount}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Nights</span>
                              <h6 class="mb-0">{items?.packageData?.nightCount}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={3}>
                    <h6>Cab Booking</h6>
                    {cabBooking?.map((items) => (
                      <div key={items?._id} class="card border mb-4">
                        <div class="card-header border-bottom d-md-flex justify-content-md-between align-items-center">
                          <div class="d-flex align-items-center">
                            <div class="icon-lg bg-light rounded-circle flex-shrink-0">
                              {/* <svg class="svg-inline--fa fa-plane" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plane" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                <path class="" fill="currentColor" d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"></path>
                              </svg> */}
                              <i className="fa-solid fa-car"></i>
                            </div>
                            <div class="ms-2">
                              <h6 class="card-title mb-0">{items?.from} to {items?.to}</h6>
                              <ul class="nav nav-divider small">
                                <li class="nav-item">Booking ID: {items?._id}</li>
                              </ul>
                            </div>
                          </div>
                          <div class="mt-2 mt-md-0">
                            <a href="#" class="btn btn-primary-soft mb-0">{items?.status === 'callNotPicked' ? 'Call Not Picked' : items?.status}</a>

                          </div>
                        </div>
                        <div class="card-body">
                          <div class="row g-3">
                            <div class="col-sm-6 col-md-4">
                              <span>Cab Type</span>
                              <h6 class="mb-0">{items?.cabType}</h6>
                            </div>
                            {items?.pickupTime && <div class="col-sm-6 col-md-4">
                              <span>Pickup time</span>
                              <h6 class="mb-0">{items?.pickupTime && new Date(items?.pickupTime).getHours() + ':' + new Date(items?.pickupTime).getMinutes() + ':' + new Date(items?.pickupTime).getSeconds()}</h6>
                            </div>}
                            {items?.pickupDate && <div class="col-sm-6 col-md-4">
                              <span>Pickup Date</span>
                              <h6 class="mb-0">{items?.pickupDate && new Date(items?.pickupDate).toDateString()}</h6>

                            </div>}
                            {items?.returnTime && <div class="col-sm-6 col-md-4">
                              <span>Return time</span>
                              <h6 class="mb-0">{items?.returnTime && new Date(items?.returnTime).getHours() + ':' + new Date(items?.returnTime).getMinutes() + ':' + new Date(items?.returnTime).getSeconds()}</h6>

                            </div>}
                            {items?.returnDate && <div class="col-sm-6 col-md-4">
                              <span>Return Date</span>
                              <h6 class="mb-0">{items?.returnDate && new Date(items?.returnDate).toDateString()}</h6>

                            </div>}
                            <div class="col-sm-6 col-md-4">
                              <span>Passenger</span>
                              <h6 class="mb-0">{items?.passengerCount}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={4}>
                    <h6>Bus Booking</h6>
                    {busBooking?.map((items) => (
                      <div key={items?._id} class="card border mb-4">
                        <div class="card-header border-bottom d-md-flex justify-content-md-between align-items-center">
                          <div class="d-flex align-items-center">
                            <div class="icon-lg bg-light rounded-circle flex-shrink-0">
                              {/* <svg class="svg-inline--fa fa-plane" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plane" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                <path class="" fill="currentColor" d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"></path>
                              </svg> */}
                              <i class="fa-solid fa-bus"></i>
                            </div>
                            <div class="ms-2">
                              <h6 class="card-title mb-0">{items?.from} to {items?.to}</h6>
                              <ul class="nav nav-divider small">
                                <li class="nav-item">Booking ID: {items?._id}</li>
                              </ul>
                            </div>
                          </div>
                          <div class="mt-2 mt-md-0">
                            <a href="#" class="btn btn-primary-soft mb-0">{items?.status === 'callNotPicked' ? 'Call Not Picked' : items?.status}</a>

                          </div>
                        </div>
                        <div class="card-body">
                          <div class="row g-3">
                            <div class="col-sm-6 col-md-4">
                              <span>Bus Type</span>
                              <h6 class="mb-0">{items?.busType}</h6>
                            </div>
                            {items?.pickupTime && <div class="col-sm-6 col-md-4">
                              <span>Pickup time</span>
                              <h6 class="mb-0">{items?.pickupTime && new Date(Number(items?.pickupTime)).getHours() + ':' + new Date(Number(items?.pickupTime)).getMinutes() + ':' + new Date(Number(items?.pickupTime)).getSeconds()}</h6>
                            </div>}
                            {items?.departureDate && <div class="col-sm-6 col-md-4">
                              <span>Pickup Date</span>
                              <h6 class="mb-0">{items?.departureDate && new Date(items?.departureDate).toDateString()}</h6>

                            </div>}
                            {items?.returnTime && <div class="col-sm-6 col-md-4">
                              <span>Return time</span>
                              <h6 class="mb-0">{items?.returnTime && new Date(Number(items?.returnTime)).getHours() + ':' + new Date(Number(items?.returnTime)).getMinutes() + ':' + new Date(Number(items?.returnTime)).getSeconds()}</h6>

                            </div>}
                            {items?.returnDate && <div class="col-sm-6 col-md-4">
                              <span>Return Date</span>
                              <h6 class="mb-0">{items?.returnDate && new Date(items?.returnDate).toDateString()}</h6>

                            </div>}
                            <div class="col-sm-6 col-md-4">
                              <span>Passenger</span>
                              <h6 class="mb-0">{items?.passengerCount}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={5}>
                    <h6>Visa Booking</h6>
                    {visaBooking?.map((items) => (
                      <div key={items?._id} class="card border mb-4">
                        <div class="card-header border-bottom d-md-flex justify-content-md-between align-items-center">
                          <div class="d-flex align-items-center">
                            <div class="icon-lg bg-light rounded-circle flex-shrink-0">
                              {/* <svg class="svg-inline--fa fa-plane" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plane" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                <path class="" fill="currentColor" d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"></path>
                              </svg> */}
                              <i className="fa-brands fa-cc-visa fa-fw"></i>
                            </div>
                            <div class="ms-2">
                              {/* <h6 class="card-title mb-0">Name</h6> */}
                              <ul class="nav nav-divider small">
                                <li class="nav-item">Booking ID: {items?._id}</li>
                              </ul>
                            </div>
                          </div>
                          <div class="mt-2 mt-md-0">
                            <a href="#" class="btn btn-primary-soft mb-0">{items?.status === 'callNotPicked' ? 'Call Not Picked' : items?.status}</a>

                          </div>
                        </div>
                        <div class="card-body">
                          <div class="row g-3">
                            <div class="col-sm-6 col-md-4">
                              <span>Visa Country</span>
                              <h6 class="mb-0">{items?.visaCountry}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Visa Type</span>
                              <h6 class="mb-0">{items?.visaType}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Visa Validity</span>
                              <h6 class="mb-0">{items?.visaValidity}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Nationality</span>
                              <h6 class="mb-0">{items?.nationality}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Passport No</span>
                              <h6 class="mb-0">{items?.passportNumber}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Name</span>
                              <h6 class="mb-0">{items?.firstName}</h6>
                            </div>
                            {items?.middleName && <div class="col-sm-6 col-md-4">
                              <span>Middle Name</span>
                              <h6 class="mb-0">{items?.middleName}</h6>
                            </div>}
                            <div class="col-sm-6 col-md-4">
                              <span>Last Name</span>
                              <h6 class="mb-0">{items?.lastName}</h6>
                            </div>

                            {items?.fatherName && <div class="col-sm-6 col-md-4">
                              <span>Father Name</span>
                              <h6 class="mb-0">{items?.fatherName}</h6>
                            </div>}
                            <div class="col-sm-6 col-md-4">
                              <span>Mother Name</span>
                              <h6 class="mb-0">{items?.motherName}</h6>
                            </div>

                            <div class="col-sm-6 col-md-4">
                              <span>Date of Issue</span>
                              <h6 class="mb-0">{new Date(items?.dateOfIssue).toDateString()}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Date of Expiry</span>
                              <h6 class="mb-0">{new Date(items?.dateOfExpiry).toDateString()}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Date of Birth</span>
                              <h6 class="mb-0">{new Date(items?.dateOfBirth).toDateString()}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Gender</span>
                              <h6 class="mb-0">{items?.gender}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Country of Birth</span>
                              <h6 class="mb-0">{items?.countryOfBirth}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Religion</span>
                              <h6 class="mb-0">{items?.religion}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Place of Birth</span>
                              <h6 class="mb-0">{items?.placeOfBirth}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>Profession</span>
                              <h6 class="mb-0">{items?.profession}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={6}>
                    <h6>Train Booking</h6>
                    {trainBooking?.map((items) => (
                      <div key={items?._id} class="card border mb-4">
                        <div class="card-header border-bottom d-md-flex justify-content-md-between align-items-center">
                          <div class="d-flex align-items-center">
                            <div class="icon-lg bg-light rounded-circle flex-shrink-0">
                              {/* <svg class="svg-inline--fa fa-plane" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plane" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                <path class="" fill="currentColor" d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"></path>
                              </svg> */}
                              <i class="fa-solid fa-train"></i>
                            </div>
                            <div class="ms-2">
                              <h6 class="card-title mb-0">{items?.from} to {items?.to}</h6>
                              <ul class="nav nav-divider small">
                                <li class="nav-item">Booking ID: {items?._id}</li>
                              </ul>
                            </div>
                          </div>
                          <div class="mt-2 mt-md-0">
                            <a href="#" class="btn btn-primary-soft mb-0">{items?.status === 'callNotPicked' ? 'Call Not Picked' : items?.status}</a>

                          </div>
                        </div>
                        <div class="card-body">
                          <div class="row g-3">
                            <div class="col-sm-6 col-md-4">
                              <span>Train Type</span>
                              <h6 class="mb-0">{items?.trainType}</h6>
                            </div>
                            {items?.pickupTime && <div class="col-sm-6 col-md-4">
                              <span>Pickup time</span>
                              <h6 class="mb-0">{items?.pickupTime && new Date(Number(items?.pickupTime)).getHours() + ':' + new Date(Number(items?.pickupTime)).getMinutes() + ':' + new Date(Number(items?.pickupTime)).getSeconds()}</h6>
                            </div>}
                            {items?.departureDate && <div class="col-sm-6 col-md-4">
                              <span>Pickup Date</span>
                              <h6 class="mb-0">{items?.departureDate && new Date(items?.departureDate).toDateString()}</h6>

                            </div>}
                            {items?.returnTime && <div class="col-sm-6 col-md-4">
                              <span>Return time</span>
                              <h6 class="mb-0">{items?.returnTime && new Date(Number(items?.returnTime)).getHours() + ':' + new Date(Number(items?.returnTime)).getMinutes() + ':' + new Date(Number(items?.returnTime)).getSeconds()}</h6>

                            </div>}
                            {items?.returnDate && <div class="col-sm-6 col-md-4">
                              <span>Return Date</span>
                              <h6 class="mb-0">{items?.returnDate && new Date(items?.returnDate).toDateString()}</h6>

                            </div>}
                            <div class="col-sm-6 col-md-4">
                              <span>Passenger</span>
                              <h6 class="mb-0">{items?.passengerCount}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={7}>
                    <h6>Cruise Booking</h6>
                    {cruiseBooking?.map((items) => (
                      <div class="card border mb-4">
                        <div class="card-header border-bottom d-md-flex justify-content-md-between align-items-center">
                          <div class="d-flex align-items-center">
                            <div class="icon-lg bg-light rounded-circle flex-shrink-0">
                              {/* <svg class="svg-inline--fa fa-plane" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plane" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                <path class="" fill="currentColor" d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"></path>
                              </svg> */}
                              <i class="fa-solid fa-ship"></i>
                            </div>
                            <div class="ms-2">
                              <h6 class="card-title mb-0">{items?.from} to {items?.to}</h6>
                              <ul class="nav nav-divider small">
                                <li class="nav-item">Booking ID: {items?._id}</li>
                              </ul>
                            </div>
                          </div>
                          <div class="mt-2 mt-md-0">
                            <a href="#" class="btn btn-primary-soft mb-0">{items?.status === 'callNotPicked' ? 'Call Not Picked' : items?.status}</a>

                          </div>
                        </div>
                        <div class="card-body">
                          <div class="row g-3">
                            <div class="col-sm-6 col-md-4">
                              <span>Cruise Type</span>
                              <h6 class="mb-0">{items?.cruiseType}</h6>
                            </div>
                            {items?.pickupTime && <div class="col-sm-6 col-md-4">
                              <span>Pickup time</span>
                              <h6 class="mb-0">{items?.pickupTime && new Date(items?.pickupTime).getHours() + ':' + new Date(items?.pickupTime).getMinutes() + ':' + new Date(items?.pickupTime).getSeconds()}</h6>
                            </div>}
                            {items?.departureDate && <div class="col-sm-6 col-md-4">
                              <span>Pickup Date</span>
                              <h6 class="mb-0">{items?.departureDate && new Date(items?.departureDate).toDateString()}</h6>

                            </div>}
                            {items?.returnTime && <div class="col-sm-6 col-md-4">
                              <span>Return time</span>
                              <h6 class="mb-0">{items?.returnTime && new Date(items?.returnTime).getHours() + ':' + new Date(items?.returnTime).getMinutes() + ':' + new Date(items?.returnTime).getSeconds()}</h6>

                            </div>}
                            {items?.returnDate && <div class="col-sm-6 col-md-4">
                              <span>Return Date</span>
                              <h6 class="mb-0">{items?.returnDate && new Date(items?.returnDate).toDateString()}</h6>

                            </div>}
                            <div class="col-sm-6 col-md-4">
                              <span>Passenger</span>
                              <h6 class="mb-0">{items?.passengerCount}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={8}>
                    <h6>Insurance Booking</h6>
                    {insuranceBooking?.map((items) => (
                      <div key={items?._id} class="card border mb-4">
                        <div class="card-header border-bottom d-md-flex justify-content-md-between align-items-center">
                          <div class="d-flex align-items-center">
                            <div class="icon-lg bg-light rounded-circle flex-shrink-0">
                              {/* <svg class="svg-inline--fa fa-plane" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plane" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
         <path class="" fill="currentColor" d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"></path>
       </svg> */}
                              <i class="fa-solid fa-hands-holding-child"></i>
                            </div>
                            <div class="ms-2">
                              <h6 class="card-title mb-0">Country you are travelling to {items?.country}</h6>
                              <ul class="nav nav-divider small">
                                <li class="nav-item">Booking ID: {items?._id}</li>
                              </ul>
                            </div>
                          </div>
                          {items?.status && <div class="mt-2 mt-md-0">
                            <a href="#" class="btn btn-primary-soft mb-0">{items?.status === 'callNotPicked' ? 'Call Not Picked' : items?.status}</a>

                          </div>}
                        </div>
                        <div class="card-body">
                          <div class="row g-3">
                            <div class="col-sm-6 col-md-4">
                              <span>Start Date</span>
                              <h6 class="mb-0">{new Date(items?.startDate).toDateString()}</h6>
                            </div>
                            <div class="col-sm-6 col-md-4">
                              <span>End Date</span>
                              <h6 class="mb-0">{new Date(items?.endDate).toDateString()}</h6>
                            </div>
                            {items?.dob && <div class="col-sm-6 col-md-4">
                              <span>DOB</span>
                              <h6 class="mb-0">{new Date(items?.dob).toDateString()}</h6>
                            </div>}
                            {items?.travelingFromIndia && <div class="col-sm-6 col-md-4">
                              <span>Traveling From</span>
                              <h6 class="mb-0">{items?.travelingFromIndia ? 'India' : ''}</h6>
                            </div>}
                            <div class="col-sm-6 col-md-4">
                              <span>Person</span>
                              <h6 class="mb-0">{items?.noOfPeople}</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  </CustomTabPanel>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </section >
      <Footer />
    </>
  )
}

export default MyBooking
